import {cancelDeliveryGroupOrders} from "../reducersFunctions/deliveryGroupReducerFunctions";
import {diffArrays} from "../../Utils/DiffUtils";
import {publish} from "../../Events/events";
import {
    DeleteAssignedGroup,
    DeleteLockedGroup,
    NewAssignedGroup,
    NewLockedGroup,
    UpdateAssignedGroup, UpdateLockedGroup
} from "../../Events/topics";

const initialState = {
    assignedDeliveryGroups: undefined,
    finishedDeliveryGroups: undefined,
    proposedDeliveryGroups: undefined,
    lockedDeliveryGroups: undefined,
    sentLockedDeliveryGroups: undefined,
    fetching: false,
    fetchingLocked: false,
    changing: false,
    fetched: false,
    fetchedLocked: false,
    evaluatingProposedDeliveryGroups: false,
    error: null,
    evaluateDeliveryGroupsError: null,
    isCancelingOrders: false
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case "FETCH_ASSIGNED_DELIVERY_GROUPS_PENDING": {
            return {
                ...state,
                fetching: true
            };
        }
        case "FETCH_ASSIGNED_DELIVERY_GROUPS_FULFILLED": {
            if (state.fetched) {
                const diffGroups = diffArrays(state.assignedDeliveryGroups.concat(state.finishedDeliveryGroups),
                    action.payload,
                    (obj) => obj.id);

                if (diffGroups.length > 0) {
                    for (let diffGroup of diffGroups) {
                        if (diffGroup.type === "add")
                            publish(NewAssignedGroup, {group: action.payload.find(o => o.id === diffGroup.id)});
                        else if (diffGroup.type === "remove") {
                            const group = state.assignedDeliveryGroups.find(o => o.id === diffGroup.id);

                            if (group)
                                publish(DeleteAssignedGroup, {group: group});
                        } else if (diffGroup.type === "update") {
                            const changes = diffGroup.changes.filter(change => ['aborted_orders', 'status'].includes(change.path[0]));

                            if (changes.length > 0)
                                publish(UpdateAssignedGroup, {
                                    group: action.payload.find(o => o.id === diffGroup.id),
                                    changes: diffGroup.changes
                                });
                        }
                    }
                }
            }

            const newAssignedDeliveryGroups = action.payload.filter(g => ["ASSIGNED", "ACCEPTED", "SEARCHING_FOR_DRIVER"].includes(g.status));
            const newFinishedDeliveryGroups = action.payload.filter(g => g.status === 'FINISHED');

            return {
                ...state,
                fetching: false,
                assignedDeliveryGroups: _.isEqual(state.assignedDeliveryGroups, newAssignedDeliveryGroups) ? state.assignedDeliveryGroups : newAssignedDeliveryGroups,
                finishedDeliveryGroups: _.isEqual(state.finishedDeliveryGroups, newFinishedDeliveryGroups) ? state.finishedDeliveryGroups : newFinishedDeliveryGroups,
                fetched: true,
                error: null
            };
        }
        case "FETCH_ASSIGNED_DELIVERY_GROUPS_REJECTED": {
            return {
                ...state,
                fetching: false,
                error: action.payload
            };
        }

        case "FETCH_LOCKED_DELIVERY_GROUPS_PENDING": {
            return {
                ...state,
                fetchingLocked: true
            };
        }
        case "FETCH_LOCKED_DELIVERY_GROUPS_FULFILLED": {
            if (state.fetchedLocked) {
                const diffGroups = diffArrays(state.lockedDeliveryGroups, action.payload, (obj) => obj.group_id);

                if (diffGroups.length > 0) {
                    for (let diffGroup of diffGroups) {
                        if (diffGroup.type === "add")
                            publish(NewLockedGroup, {group: action.payload.find(o => o.group_id === diffGroup.group_id)});
                        else if (diffGroup.type === "remove") {
                            const group = state.lockedDeliveryGroups.find(o => o.group_id === diffGroup.group_id);

                            if (group)
                                publish(DeleteLockedGroup, {group: group});
                        } else if (diffGroup.type === "update") {
                            const changes = diffGroup.changes.filter(change => ['aborted_orders', 'status'].includes(change.path[0]));

                            if (changes.length > 0)
                                publish(UpdateLockedGroup, {
                                    group: action.payload.find(o => o.group_id === diffGroup.group_id),
                                    changes: diffGroup.changes
                                });
                        }
                    }
                }
            }

            const newLockedDeliveryGroups = action.payload.filter(g => ["LOCKED"].includes(g.status));
            const newSentLockedDeliveryGroups = action.payload.filter(g => g.status === 'SENT');

            return {
                ...state,
                fetchingLocked: false,
                fetchedLocked: true,
                lockedDeliveryGroups: _.isEqual(state.lockedDeliveryGroups, newLockedDeliveryGroups) ? state.lockedDeliveryGroups : newLockedDeliveryGroups,
                sentLockedDeliveryGroups: _.isEqual(state.sentLockedDeliveryGroups, newSentLockedDeliveryGroups) ? state.sentLockedDeliveryGroups : newSentLockedDeliveryGroups,
                error: null
            };
        }
        case "FETCH_LOCKED_DELIVERY_GROUPS_REJECTED": {
            return {
                ...state,
                fetchingLocked: false,
                error: action.payload
            };
        }

        case "EVALUATE_DELIVERY_GROUPS_PENDING": {
            return {
                ...state,
                evaluatingDeliveryGroupsRequestId: action.meta.requestId,
                evaluatingProposedDeliveryGroups: action.meta.isSpecific ? state.evaluatingProposedDeliveryGroups : true
            };
        }
        case "EVALUATE_DELIVERY_GROUPS_FULFILLED": {
            // Check if its the latest evaluation, if not, ignore it
            // TODO: Make previous evaluations stop (fix current behaviour)
            if (action.payload && action.payload.requestId !== state.evaluatingDeliveryGroupsRequestId)
                return state;

            if (!action.payload || !action.payload.success) {
                let messageType = "Unknown";

                if (action.payload && action.payload.messageType)
                    messageType = action.payload.messageType;

                return {
                    ...state,
                    proposedDeliveryGroups: [],
                    evaluatingProposedDeliveryGroups: false,
                    evaluateDeliveryGroupsError: {type: messageType}
                };
            }

            let newProposedDeliveryGroups;

            if (action.meta.isSpecific) {
                newProposedDeliveryGroups = [...state.proposedDeliveryGroups];

                const newGroup = action.payload["deliveryGroups"]["delivery_groups"][0];

                const groupIndex = newProposedDeliveryGroups.findIndex(a => a.id === newGroup.id);

                if (groupIndex > -1)
                    newProposedDeliveryGroups[groupIndex] = newGroup;
            } else
                newProposedDeliveryGroups = action.payload["deliveryGroups"]["delivery_groups"];

            return {
                ...state,
                proposedDeliveryGroups: newProposedDeliveryGroups,
                evaluatingProposedDeliveryGroups: false,
                evaluateDeliveryGroupsError: null
            };
        }
        case "EVALUATE_DELIVERY_GROUPS_REJECTED": {
            return {
                ...state,
                proposedDeliveryGroups: [],
                evaluatingProposedDeliveryGroups: false,
                error: action.payload
            };
        }

        case "SEND_DELIVERY_GROUP_PENDING": {
            return {
                ...state,
                changing: true
            };
        }
        case "SEND_DELIVERY_GROUP_FULFILLED": {
            const isNewGroupAlreadyIn = state.assignedDeliveryGroups.some(g => g.id === action.payload.details.group.id);

            let newLockedDeliveryGroups = state.lockedDeliveryGroups;
            let newSentLockedDeliveryGroups = state.sentLockedDeliveryGroups;
            const foundLockedGroupIndex = state.lockedDeliveryGroups.findIndex(g => g.group_id === action.payload.details.group.id);

            if (foundLockedGroupIndex !== -1) {
                newLockedDeliveryGroups = [...state.lockedDeliveryGroups];
                newSentLockedDeliveryGroups = [...state.sentLockedDeliveryGroups];

                newSentLockedDeliveryGroups.push(newLockedDeliveryGroups[foundLockedGroupIndex]);
                newLockedDeliveryGroups.splice(foundLockedGroupIndex, 1);
            }

            return {
                ...state,
                assignedDeliveryGroups: isNewGroupAlreadyIn ?
                    state.assignedDeliveryGroups :
                    state.assignedDeliveryGroups.concat([action.payload.details.group]),
                proposedDeliveryGroups: state.proposedDeliveryGroups.filter(deliveryGroup => deliveryGroup.id !== action.meta.id),
                lockedDeliveryGroups: newLockedDeliveryGroups,
                sentLockedDeliveryGroups: newSentLockedDeliveryGroups,
                changing: false,
                error: null
            };
        }
        case "SEND_DELIVERY_GROUP_REJECTED": {
            return {
                ...state,
                changing: false,
                error: action.payload
            };
        }


        case "EDIT_DELIVERY_GROUP_PENDING": {
            return {
                ...state,
                changing: true
            };
        }
        case "EDIT_DELIVERY_GROUP_FULFILLED": {
            const newAssignedDeliveryGroups = [...state.assignedDeliveryGroups];

            const foundAssignedGroupIndex = newAssignedDeliveryGroups.findIndex(g => g.id === action.meta.id);

            if (foundAssignedGroupIndex !== -1)
                newAssignedDeliveryGroups[foundAssignedGroupIndex] = action.payload.details.group;

            return {
                ...state,
                assignedDeliveryGroups: newAssignedDeliveryGroups,
                changing: false,
                error: null
            };
        }
        case "EDIT_DELIVERY_GROUP_REJECTED": {
            return {
                ...state,
                changing: false,
                error: action.payload
            };
        }

        case "CANCEL_DELIVERY_GROUP_ORDERS_PENDING": {
            const {ordersIds, deliveryGroupId} = action.meta;
            const deliveryGroups = cancelDeliveryGroupOrders(state.assignedDeliveryGroups, deliveryGroupId, ordersIds);

            let newSentLockedDeliveryGroups = state.sentLockedDeliveryGroups;
            const foundDeliveryGroupIndex = deliveryGroups.findIndex(g => g.id === deliveryGroupId);

            if (foundDeliveryGroupIndex === -1) {
                const foundSentLockedGroupIndex = state.sentLockedDeliveryGroups.findIndex(g => g.group_id === deliveryGroupId);
                if (foundSentLockedGroupIndex !== -1) {
                    newSentLockedDeliveryGroups = [...state.sentLockedDeliveryGroups];
                    newSentLockedDeliveryGroups.splice(foundSentLockedGroupIndex, 1);
                }
            }

            return {
                ...state,
                assignedDeliveryGroups: deliveryGroups,
                sentLockedDeliveryGroups: newSentLockedDeliveryGroups,
                changing: true
            };
        }
        case "CANCEL_DELIVERY_GROUP_ORDERS_FULFILLED": {
            return {
                ...state,
                changing: false,
                error: null
            }
        }
        case "CANCEL_DELIVERY_GROUP_ORDERS_REJECTED": {
            return {
                ...state,
                changing: false,
                error: action.payload
            };
        }

        case "CANCEL_DELIVERY_GROUP_PENDING": {
            const {deliveryGroupId} = action.meta;
            const deliveryGroups = cancelDeliveryGroupOrders(state.assignedDeliveryGroups, deliveryGroupId);

            let newSentLockedDeliveryGroups = state.sentLockedDeliveryGroups;
            const foundSentLockedGroupIndex = state.sentLockedDeliveryGroups.findIndex(g => g.group_id === deliveryGroupId);
            if (foundSentLockedGroupIndex !== -1) {
                newSentLockedDeliveryGroups = [...state.sentLockedDeliveryGroups];
                newSentLockedDeliveryGroups.splice(foundSentLockedGroupIndex, 1);
            }

            return {
                ...state,
                changing: true,
                assignedDeliveryGroups: deliveryGroups,
                sentLockedDeliveryGroups: newSentLockedDeliveryGroups
            }
        }
        case "CANCEL_DELIVERY_GROUP_FULFILLED": {
            return {
                ...state,
                changing: false,
                error: null
            }
        }
        case "CANCEL_DELIVERY_GROUP_REJECTED": {
            return {
                ...state,
                changing: false,
                error: action.payload
            };
        }

        case "LOCK_DELIVERY_GROUP_FULFILLED": {
            const newLockedDeliveryGroups = [...state.lockedDeliveryGroups];
            const foundLockedGroupIndex = state.lockedDeliveryGroups.findIndex(g => g.group_id === action.meta.groupId);

            const newLockedGroup = {
                "group_id": action.meta.groupId,
                "bid": action.meta.bid,
                "order_ids": action.meta.orderIds,
                "timestamp": new Date().toISOString(),
                "is_ordered": !!action.meta.isOrdered,
                "is_order_changed": !!action.meta.isOrderChanged,
                "is_messenger_changed": !!action.meta.isMessengerChanged,
                "is_route_orders_changed": !!action.meta.isRouteOrdersChanged,
                "status": "LOCKED"
            }

            if (action.meta.messengerId)
                newLockedGroup.messenger_id = action.meta.messengerId;

            if (foundLockedGroupIndex !== -1)
                newLockedDeliveryGroups[foundLockedGroupIndex] = newLockedGroup;
            else
                newLockedDeliveryGroups.push(newLockedGroup)

            return {
                ...state,
                lockedDeliveryGroups: newLockedDeliveryGroups,
                error: null
            };
        }

        case "UNLOCK_DELIVERY_GROUP_FULFILLED": {
            const newLockedDeliveryGroups = [...state.lockedDeliveryGroups];
            const foundLockedGroupIndex = state.lockedDeliveryGroups.findIndex(g => g.group_id === action.meta.groupId);
            if (foundLockedGroupIndex !== -1)
                newLockedDeliveryGroups.splice(foundLockedGroupIndex, 1);

            return {
                ...state,
                lockedDeliveryGroups: newLockedDeliveryGroups,
                error: null
            };
        }

        case "LOCK_MESSENGER_TO_GROUP_FULFILLED": {
            const newLockedDeliveryGroups = [...state.lockedDeliveryGroups];
            const foundLockedGroupIndex = state.lockedDeliveryGroups.findIndex(g => g.group_id === action.meta.groupId);

            if (foundLockedGroupIndex !== -1) {
                newLockedDeliveryGroups[foundLockedGroupIndex] = {...newLockedDeliveryGroups[foundLockedGroupIndex]};
                const foundLockedGroup = newLockedDeliveryGroups[foundLockedGroupIndex];

                foundLockedGroup.messenger_id = action.meta.messengerId;

                if (action.meta.isMessengerChanged)
                    foundLockedGroup.is_messenger_changed = action.meta.isMessengerChanged;
            }

            return {
                ...state,
                lockedDeliveryGroups: newLockedDeliveryGroups,
                error: null
            };
        }

        case "UNLOCK_MESSENGER_FROM_GROUP_FULFILLED": {
            const newLockedDeliveryGroups = [...state.lockedDeliveryGroups];
            const foundLockedGroupIndex = state.lockedDeliveryGroups.findIndex(g => g.group_id === action.meta.groupId);

            if (foundLockedGroupIndex !== -1) {
                newLockedDeliveryGroups[foundLockedGroupIndex] = {...newLockedDeliveryGroups[foundLockedGroupIndex]};
                const foundLockedGroup = newLockedDeliveryGroups[foundLockedGroupIndex];

                delete foundLockedGroup.messenger_id;

                foundLockedGroup.is_messenger_changed = false;
            }

            return {
                ...state,
                lockedDeliveryGroups: newLockedDeliveryGroups,
                error: null
            };
        }

        case "REMOVE_ORDERS_FROM_LOCKED_DELIVERY_GROUP_FULFILLED": {
            const newLockedDeliveryGroups = [...state.lockedDeliveryGroups];
            const foundLockedGroupIndex = state.lockedDeliveryGroups.findIndex(g => g.group_id === action.meta.groupId);

            if (foundLockedGroupIndex !== -1) {
                newLockedDeliveryGroups[foundLockedGroupIndex] = {...newLockedDeliveryGroups[foundLockedGroupIndex]};
                const foundLockedGroup = newLockedDeliveryGroups[foundLockedGroupIndex];
                foundLockedGroup.order_ids = foundLockedGroup.order_ids.filter(oid => !action.meta.orderIds.includes(oid));
                foundLockedGroup.is_ordered = false;
                foundLockedGroup.is_route_orders_changed = true;

                if (foundLockedGroup.order_ids.length === 0)
                    newLockedDeliveryGroups.splice(foundLockedGroupIndex, 1);
            }

            return {
                ...state,
                lockedDeliveryGroups: newLockedDeliveryGroups
            };
        }

        case "ADD_ORDERS_TO_LOCKED_DELIVERY_GROUP_FULFILLED": {
            const newLockedDeliveryGroups = [...state.lockedDeliveryGroups];
            const foundLockedGroupIndex = state.lockedDeliveryGroups.findIndex(g => g.group_id === action.meta.groupId);

            if (foundLockedGroupIndex !== -1) {
                newLockedDeliveryGroups[foundLockedGroupIndex] = {...newLockedDeliveryGroups[foundLockedGroupIndex]};
                const foundLockedGroup = newLockedDeliveryGroups[foundLockedGroupIndex];
                foundLockedGroup.order_ids = foundLockedGroup.order_ids.concat(action.meta.orderIds);
                foundLockedGroup.is_ordered = false;
                foundLockedGroup.is_route_orders_changed = true;
            }

            return {
                ...state,
                lockedDeliveryGroups: newLockedDeliveryGroups
            };
        }

        case 'FINISH_DELIVERY_DELIVERY_GROUP_FULFILLED': {
            const newAssignedDeliveryGroups = [...state.assignedDeliveryGroups];
            const newFinishedDeliveryGroups = [...state.finishedDeliveryGroups];

            const deliveryGroupIndex = newAssignedDeliveryGroups.findIndex(value => value.id === action.meta.groupId);

            if (deliveryGroupIndex !== -1) {
                const newDeliveryGroup = {...newAssignedDeliveryGroups[deliveryGroupIndex], status: "FINISHED"};
                newFinishedDeliveryGroups.push(newDeliveryGroup);

                newAssignedDeliveryGroups.splice(deliveryGroupIndex, 1);
            }

            return {
                ...state,
                assignedDeliveryGroups: newAssignedDeliveryGroups,
                finishedDeliveryGroups: newFinishedDeliveryGroups
            };
        }
    }

    return state;
}